<template>
    <div>
        <div class="flex items-center mb-1">
            <div class="creator-cube" :style="{ backgroundColor: comment.creator.color }"></div>
            <span class="ml-2 leading-none font-medium">{{ comment.creator.first_name }}</span>
            <span class="ml-2 leading-none">|</span>
            <span class="ml-2 leading-none">{{ $moment(comment.created_at).format('DD/MM/YYYY - HH:mm') }}</span>
        </div>
        <div class="flex items-start justify-between w-full">
            <p class="leading-4 mr-3" :id="'demand-comment-' + comment.id">{{ comment.text }}</p>
            <div v-if="canEdit">
                <md-button class="md-icon-button md-raised md-warning" @click="updating = true">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                </md-button>
                <md-tooltip md-direction="top">Modifier</md-tooltip>
            </div>
        </div>
        <div v-if="updating" class="mt-3 flex items-start w-full justify-between">
            <md-field class="md-invalid">
                <label>Commentaire</label>
                <md-textarea v-model="editComment" name="comment" required md-autogrow></md-textarea>
                <validation-error :errors="apiValidationErrors.comment" />
            </md-field>
            <div class="flex items-center">
                <div class="ml-3">
                    <md-button class="md-icon-button md-raised md-danger" @click="updating = false">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                    </md-button>
                    <md-tooltip md-direction="top">Annuler</md-tooltip>
                </div>
                <div>
                    <md-button class="md-icon-button md-raised md-success" @click="updateComment">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'check']" />
                    </md-button>
                    <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "DemandCommentRow",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        comment: Object,
        canEdit: Boolean
    },
    data() {
        return {
            updating: false,
            editComment: ''
        }
    },
    methods: {
        async updateComment() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('demandComments/updateDemandComment', {
                    demandCommentId: this.comment.id,
                    comment: this.editComment
                })
                await this.$store.dispatch('alerts/success', 'Commentaire modifié')
                this.updating = false
                this.$emit('updated')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        formatComment() {
            document.getElementById('demand-comment-' + this.comment.id).innerHTML = this.nl2br(this.comment.text)
        },
        nl2br(str, replaceMode, isXhtml) {
            let breakTag = (isXhtml) ? '<br />' : '<br>';
            let replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
        },
    },
    mounted() {
        this.editComment = _.cloneDeep(this.comment.text)
        this.formatComment()
    },
    watch: {
        'comment.text'() {
            this.formatComment()
        }
    }
}
</script>

<style scoped lang="scss">
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
}
</style>
